export const fileUploadTokens = {
  'upload-height': '160px',
  'upload-border-color': 'var(--dp-color-border)',
  'upload-border-style': 'dashed',
  'upload-border-width': '2px',
  'upload-border-radius': 'var(--dp-border-radius-lg)',
  'upload-bg': 'var(--dp-color-surface)',
  'upload-hover-bg': 'var(--dp-color-surface-hover)',
  'upload-active-border-color': 'var(--dp-color-primary)',
  'upload-icon-size': '40px',
  'upload-icon-color': 'var(--dp-color-text-tertiary)',
  'upload-text-color': 'var(--dp-color-text-secondary)',
  'upload-hint-color': 'var(--dp-color-text-tertiary)',
} as const;
